import styled from "styled-components";

export const StyledTitle = styled.h3`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 110%;
`
